









































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import MiniHelpMessage from '../../../../MiniHelpMessage/MiniHelpMessage.vue'
import Tags from '../../../../Tags/Tags.vue'
import { SelectOptionData } from '../../../types'

@Component({
  components: {
    Tags,
    MiniHelpMessage,
  },
})
export default class SelectOption extends Vue {
  @Prop() readonly data!: SelectOption
}
